<template>
    <div class="syccxhz" v-loading="loading">
        <div class="syccxhzHeader">
            <!--          <div></div>-->
            <div class="sycBottom">
                <p>Production and Sales of Passenger Car (by Model) in {{returnEnY(date[1])}} {{date[0]}}</p>
            </div>
            <div class="sycDan">
                <p>in unit</p>
            </div>
        </div>
        <div>
            <table border="1" style="width: 100%;padding: 5px" class="hisTable" id="tal">
                <thead>
                     <tr class="headerClass">
                        <td rowspan="3" colspan="4">Manufacturer</td>
                        <td colspan="6">Production</td>
                        <td colspan="6">Sales</td>
                        <td colspan="2" >Sales/Production,%</td>
                       
                    </tr>
                    <tr class="headerClass">
                        <td rowspan="2">{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{parseInt(date[0].substring(date[0].length - 2))-1}}</td>
                        <td colspan="3">Change %</td>
                        <td rowspan="2">{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{parseInt(date[0].substring(date[0].length - 2))-1}}</td>
                        <td colspan="3">Change %</td>
                    
                        <td rowspan="2">{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                    </tr>
                    <tr class="headerClass">
                        
                        <td>Prior Month</td>
                        <td>The same month of previous year</td>
                        <td>YTD</td>
                        <td>Prior Month</td>
                        <td>The same month of previous year</td>
                        <td>YTD</td>
                       
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in tableData" :key="index">

                       <td v-if="item.zhibiao1_english == 'Basic Car' && item.zhibiao1_englishdis != 'none'" :rowspan="item.zhibiao1_englishspan">{{item.zhibiao1_english}}</td>
                        <td v-if="item.zhibiao1_english == 'MPV' && item.zhibiao1_englishdis != 'none'" :rowspan="item.zhibiao1_englishspan">{{item.zhibiao1_english}}</td>
                        <td v-if="item.zhibiao1_english == 'SUV' && item.zhibiao1_englishdis != 'none'" :rowspan="item.zhibiao1_englishspan">{{item.zhibiao1_english}}</td>
                        <td v-if="item.zhibiao1_english == 'Cross Passenger Car' && item.zhibiao1_englishdis != 'none'" :rowspan="item.zhibiao1_englishspan">{{item.zhibiao1_english}}</td>

                         <td v-if="item.zhibiao2_english == 'Domestic-made' && item.zhibiao2_englishdis != 'none'" :rowspan="item.zhibiao2_englishspan">{{item.zhibiao2_english}}</td>
                         <td v-if="item.zhibiao2_english == 'CKD' && item.zhibiao2_englishdis != 'none'" :rowspan="item.zhibiao2_englishspan">{{item.zhibiao2_english}}</td>


                            <td v-if="item.zhibiao3_english == '1：in which' && item.zhibiao3_englishdis != 'none'" :rowspan="item.zhibiao3_englishspan">{{item.zhibiao3_english}}</td>
                          <td v-if="item.zhibiao3_english == '2：in which' && item.zhibiao3_englishdis != 'none'" :rowspan="item.zhibiao3_englishspan">{{item.zhibiao3_english}}</td>



                        <td v-if="item.zhibiao4_english == 'Passenger Car Total' && item.zhibiao4_englishdis != 'none'" colspan="4" v-html="returnFont(item,'zhibiao4_english')"></td>
                         <td v-else-if="item.zhibiao4_english == 'Total' && item.zhibiao4_englishdis != 'none'" colspan="3" v-html="returnFont(item,'zhibiao4_english')"></td>
                         <td v-else-if="item.zhibiao4_english == 'Domestic-made Total' && item.zhibiao4_englishdis != 'none'" colspan="2" v-html="returnFont(item,'zhibiao4_english')"></td>
                         <td v-else-if="item.zhibiao4_english == 'CKD Total' && item.zhibiao4_englishdis != 'none'" colspan="2" v-html="returnFont(item,'zhibiao4_english')"></td>
                          <td v-else-if="item.zhibiao4_englishdis != 'none'">{{item.zhibiao4_english}}</td>

                        

                       
                        <td v-html="returnFont(item,'scBywc')"></td>
                        <td v-html="returnFont(item,'scBqzlj')"></td>
                        <td v-html="returnFont(item,'scTqzlj')"></td>
                        <td v-html="returnFont(item,'scBsyzz')"></td>
                        <td v-html="returnFont(item,'scBtqzz')"></td>
                        <td v-html="returnFont(item,'scBtqljzz')"></td>

                        <td v-html="returnFont(item,'xsBywc')"></td>
                        <td v-html="returnFont(item,'xsBqzlj')"></td>
                        <td v-html="returnFont(item,'xsTqzlj')"></td>
                        <td v-html="returnFont(item,'xsBsyzz')"></td>
                        <td v-html="returnFont(item,'xsBtqzz')"></td>
                        <td v-html="returnFont(item,'xsBtqljzz')"></td>

                         <td v-html="returnFont(item,'bycxl')"></td>
                        <td v-html="returnFont(item,'bqcxl')"></td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</template>
<script>
import { getCycfcxCxqkb } from "@/api/data";
import { combineCell } from "@/utils/tableData.js";
export default {
    data() {
        return {
            tableData: [],
            date: null,
            loading:true
        };
    },
    created() {
        let date = this.$route.params.date;
        this.date = date.split("-");
        this.getCycfcxCxqkb(date.split("-").join(""));
    },
    methods: {
        getCycfcxCxqkb(date) {
            getCycfcxCxqkb({ dataDate: date }).then((res) => {
                if (res.code == 200) {
                    this.tableData = combineCell(res.data);
                }
                this.loading = false
            });
        },
         returnFont(item,sd){
            if(item.zhibiao4_english.includes('Total')){
                return '<strong>'+item[sd]+'</strong>'
            }else{
                 return item[sd]
            }
        },
        returnEnY(m) {
            let str = "";
            switch (m) {
                case "01":
                    str = "January";
                    break;
                case "02":
                    str = "February";
                    break;
                case "03":
                    str = "March";
                    break;
                case "04":
                    str = "April";
                    break;
                case "05":
                    str = "May";
                    break;
                case "06":
                    str = "June";
                    break;
                case "07":
                    str = "July";
                    break;
                case "08":
                    str = "August";
                    break;
                case "09":
                    str = "September";
                    break;
                case "10":
                    str = "October";
                    break;
                case "11":
                    str = "November";
                    break;
                case "12":
                    str = "December";
                    break;
            }
            return str;
        },
        returnEng(m) {
            let str = "";
            switch (m) {
                case "01":
                    str = "Jan";
                    break;
                case "02":
                    str = "Feb";
                    break;
                case "03":
                    str = "Mar";
                    break;
                case "04":
                    str = "Apr";
                    break;
                case "05":
                    str = "May";
                    break;
                case "06":
                    str = "Jun";
                    break;
                case "07":
                    str = "Jul";
                    break;
                case "08":
                    str = "Aug";
                    break;
                case "09":
                    str = "Sep";
                    break;
                case "10":
                    str = "Oct";
                    break;
                case "11":
                    str = "Nov";
                    break;
                case "12":
                    str = "Dec";
                    break;
            }
            return str;
        },
    },
};
</script>
<style scoped lang="css">
.hisTable {
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
}
.headerClass {
    font-size: 16px;
    color: white;
    background-color: #0d57bc;
}
.trOne {
    font-weight: bold;
}
.syccxhzHeader {
    width: 100%;
    height: 90px;

    font-size: 21px;
    text-align: center;
}
.sycBottom {
    width: 100%;
    height: 70px;
    line-height: 70px;

    float: right;
    font-weight: bold;
}
.sycDan {
    width: 10%;
    height: 20px;

    float: right;
    font-size: 13px;
}

</style>